/**
 * Created by Ning Jiang on 6/20/2018.
 */

import {GameMode, IGameModeChangedData} from "@nolimitcity/slot-game/bin/core/gamemode/GameMode";

export interface IFruitsGameModeChangedData extends IGameModeChangedData {
    animate?:boolean;
    showIntro?:boolean;
    isRestoreAndTriggered?:boolean;
}

export class FruitsGameMode extends GameMode {

    public static readonly STICKY_RESPIN:string = "STICKY_RESPIN";
    public static readonly RANDOM_OVERLAY:string = "RANDOM_OVERLAY";
    public static readonly BONUS_GAME:string = "BONUS_GAME";
}